export default __webpack_public_path__ + "static/media/photo--sm--huda-6.ed09edcf.jpg";